import React, { Component } from 'react';

import {NavLink} from 'react-router-dom';

class Navlink extends Component {

    scrollToTop(){
        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 50);
    }
  render() {
    return (
    <NavLink
      to={this.props.to}
      exact={this.props.exact !== undefined ? this.props.exact : this.props.to === '/'}
      className={this.props.className}
      activeClassName={this.props.activeClassName}
      onClick={this.scrollToTop.bind(this)}
    >{this.props.children}</NavLink>
    );
  }
}

export default Navlink;
